export default __webpack_public_path__ + "static/media/no_data.f46fbd3d.svg";